let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7GCim")).then(() => parcelRequire('iOphm'));